export const normalizeRichTextFields = (data: any): any => {
  if (!data || typeof data !== 'object') {
    return data;
  }

  const normalized = Array.isArray(data) ? [...data] : { ...data };

  const richTextFields = ['description', 'responseDescription', 'customTopic'];

  const normalizeValue = (value: any) => {
    if (typeof value === 'string') {
      return value;
    }
    if (value && typeof value === 'object') {
      return JSON.stringify(value);
    }
    return value;
  };

  if (Array.isArray(normalized)) {
    for (let i = 0; i < normalized.length; i++) {
      if (normalized[i] && typeof normalized[i] === 'object') {
        normalized[i] = normalizeRichTextFields(normalized[i]);
      }
    }
  } else {
    for (const key in normalized) {
      if (richTextFields.includes(key)) {
        normalized[key] = normalizeValue(normalized[key]);
      } else if (normalized[key] && typeof normalized[key] === 'object') {
        normalized[key] = normalizeRichTextFields(normalized[key]);
      }
    }
  }

  return normalized;
};
